<template>
  <div class="dataDesks">
    <div class="deskContainer">
      <BaseSmallDesk class="deskStyle"
                     v-for="(element, index) in dataDesk[0]"
                     :key="index"
                     :deskNumber="element.data"
                     :deskSubtitle="element.title"
                      :total="element.total">
      </BaseSmallDesk>
    </div>
  </div>
</template>

<script>
import BaseSmallDesk from './BaseSmallDesk.vue';

export default {
  name: 'GeocodeSummary',
  components: {
    BaseSmallDesk,
  },
  props: {
    dataDesk: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .deskContainer {
    display: flex;
    width: 100%;
    padding: 0 10px 10px 10px;
    //background: $fb-grey-light-97;
    box-sizing: border-box;
  }
  .dataDesks {
    display: flex;
  }
  .deskStyle {
    background: white;
    padding: 10px;
  }
</style>
